import React from 'react';
import './PetAnimations.css';

export default function StarSpriteSvg({ size = 120, color, className = '' }) {
  const goldDeep = color || '#E8A21A';
  const goldBright = '#FFD84A';
  const goldPale = '#FFF1A6';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="starGrad" cx="0.4" cy="0.35" r="0.7">
          <stop offset="0%" stopColor={goldPale} />
          <stop offset="60%" stopColor={goldBright} />
          <stop offset="100%" stopColor={goldDeep} />
        </radialGradient>
      </defs>
      {/* Halo glow */}
      <circle cx="60" cy="60" r="48" fill={goldPale} opacity="0.15" />
      <circle cx="60" cy="60" r="38" fill={goldBright} opacity="0.18" />
      {/* Star body */}
      <path
        d="M60 14L70 46L104 46L76 66L86 98L60 78L34 98L44 66L16 46L50 46Z"
        fill="url(#starGrad)"
        stroke={goldDeep}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* Highlight on upper-left point */}
      <path d="M60 18L66 42L52 46Z" fill={goldPale} opacity="0.5" />
      {/* Face area */}
      <circle cx="60" cy="58" r="14" fill={goldBright} opacity="0.4" />
      {/* Eyes (closed happy crescents) */}
      <path d="M48 56C49 60 53 60 54 56" stroke="#5A3A08" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M66 56C67 60 71 60 72 56" stroke="#5A3A08" strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Smile */}
      <path d="M54 64C56 70 64 70 66 64" stroke="#5A3A08" strokeWidth="1.8" strokeLinecap="round" fill="none" />
      {/* Rosy cheeks */}
      <circle cx="50" cy="64" r="2.5" fill="#FF8A8A" opacity="0.5" />
      <circle cx="70" cy="64" r="2.5" fill="#FF8A8A" opacity="0.5" />
      {/* Sparkles */}
      <path d="M22 30L24 26L26 30L24 34Z" fill="white" opacity="0.7" />
      <path d="M96 28L98 24L100 28L98 32Z" fill="white" opacity="0.6" />
      <path d="M16 78L17 76L18 78L17 80Z" fill="white" opacity="0.5" />
      <path d="M102 80L103 78L104 80L103 82Z" fill="white" opacity="0.5" />
    </svg>
  );
}
